/* eslint-disable no-param-reassign */
export default {
    /**
     * @override
     */
    SET_TABS(state, tabs) {
        state.tabs = tabs;
    },
    /**
     * @override
     */
    SET_NEW_FLOAT_WINDOW(state, payload) {
        state.tabs.push(payload);
    },
    /**
     * @override
     */
    REMOVE_FLOAT_WINDOW(state, payload) {
        state.tabs = state.tabs.filter(x => x.uuid !== payload);
    }
};
